module.exports = __webpack_public_path__ + "img/employer_benefit_hero.fe0fc789.jpg";